import classnames from "classnames/bind";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.css";
import { hideSortOverlay } from "../../state/modules/layout/actions";
import { getSortOverlayVisible } from "../../state/modules/layout/selectors";
import TrapFocus from "../TrapFocus";
import Escapable from "../Escapable";

const styleContext = classnames.bind(styles);

export const SortLayout = ({ children }) => {
  const dispatch = useDispatch();
  const isSortOverlayVisible = useSelector(getSortOverlayVisible);
  const layout = styleContext({
    filterLayout: true,
    showOnMobile: isSortOverlayVisible
  });

  const handleClick = () => {
    if (isSortOverlayVisible) {
      dispatch(hideSortOverlay());
    }
  };

  return (
    <div className={styles.container}>
      <Escapable escapeHandler={handleClick} />
      <div className={layout}>
        <aside
          className={styles.grayTapArea}
          onClick={handleClick}
          aria-hidden={true}
        />
        <TrapFocus
          className={styles.filterContainer}
          trapFocus={isSortOverlayVisible}
        >
          {children}
        </TrapFocus>
      </div>
    </div>
  );
};

SortLayout.propTypes = {
  children: PropTypes.node.isRequired
};

SortLayout.displayName = "SortLayout";

export default SortLayout;
